import React, { useContext } from 'react';
import { AppContext } from 'App.context';
import { Checkbox } from 'antd';

export default function ViewRolsModal() {
  const {
    appActions: { translate },
  } = useContext(AppContext);

  const permissions = [
    // configuration
    { key: 'config', label: translate('team.viewRoles.config') },
    { key: 'manage_hotels', label: translate('team.viewRoles.manage_hotels') },
    { key: 'config_pms', label: translate('team.viewRoles.config_pms') },
    { key: 'forms', label: translate('team.viewRoles.forms') },
    { key: 'set_appearance', label: translate('team.viewRoles.set_appearance') },
    { key: 'subscriptions', label: translate('team.viewRoles.subscriptions') },
    { key: 'payments', label: translate('team.viewRoles.payments') },
    { key: 'doorOpening', label: translate('team.viewRoles.doorOpening') },
    { key: 'police_report_config', label: translate('team.viewRoles.police_report_config') },
    { key: 'police_report_panel', label: translate('team.viewRoles.police_report_panel') },
    { key: 'legal_documents', label: translate('team.viewRoles.legal_documents') },
    { key: 'sftp_check_in', label: translate('team.viewRoles.sftp_check_in') },
    { key: 'guestlink', label: translate('team.viewRoles.guestlink') },
    { key: 'paperless_push', label: translate('team.viewRoles.paperless_push') },

    // dashboard
    { key: 'resume', label: translate('team.viewRoles.resume') },
    { key: 'check_ins', label: translate('team.viewRoles.check_ins') },
    { key: 'reservations', label: translate('team.viewRoles.reservations') },
    { key: 'marketing', label: translate('team.viewRoles.marketing') },
    { key: 'up_sell', label: translate('team.viewRoles.up_sell') },
    { key: 'cross_sell', label: translate('team.viewRoles.cross_sell') },

    // account
    { key: 'team', label: translate('team.viewRoles.team') },
    { key: 'billing', label: translate('team.viewRoles.billing') },
  ];

  const roles = [
    translate('team.newUserDetail.permissions.admin'),
    translate('team.newUserDetail.permissions.user'),
    translate('team.newUserDetail.permissions.guest'),
  ];

  // Estado para permisos por rol con ver y editar (solo lectura)
  // Estructura: activePermissions[permKey][rol] = { view: bool, edit: bool }
  const activePermissions = {
    config: {
      [roles[0]]: { view: true, edit: true },
      [roles[1]]: { view: true, edit: true },
      [roles[2]]: { view: true, edit: false },
    },
    manage_hotels: {
      [roles[0]]: { view: true, edit: true },
      [roles[1]]: { view: true, edit: true },
      [roles[2]]: { view: false, edit: false },
    },
    set_appearance: {
      [roles[0]]: { view: true, edit: true },
      [roles[1]]: { view: true, edit: true },
      [roles[2]]: { view: true, edit: false },
    },
    config_pms: {
      [roles[0]]: { view: true, edit: true },
      [roles[1]]: { view: false, edit: false },
      [roles[2]]: { view: false, edit: false },
    },
    payments: {
      [roles[0]]: { view: true, edit: true },
      [roles[1]]: { view: true, edit: false },
      [roles[2]]: { view: true, edit: false },
    },
    subscriptions: {
      [roles[0]]: { view: true, edit: true },
      [roles[1]]: { view: false, edit: false },
      [roles[2]]: { view: false, edit: false },
    },
    doorOpening: {
      [roles[0]]: { view: true, edit: true },
      [roles[1]]: { view: false, edit: false },
      [roles[2]]: { view: false, edit: false },
    },
    police_report_config: {
      [roles[0]]: { view: true, edit: true },
      [roles[1]]: { view: false, edit: false },
      [roles[2]]: { view: false, edit: false },
    },
    police_report_panel: {
      [roles[0]]: { view: true, edit: true },
      [roles[1]]: { view: true, edit: true },
      [roles[2]]: { view: true, edit: true },
    },
    legal_documents: {
      [roles[0]]: { view: true, edit: true },
      [roles[1]]: { view: true, edit: true },
      [roles[2]]: { view: false, edit: false },
    },
    guestlink: {
      [roles[0]]: { view: true, edit: true },
      [roles[1]]: { view: true, edit: true },
      [roles[2]]: { view: false, edit: false },
    },
    sftp_check_in: {
      [roles[0]]: { view: true, edit: true },
      [roles[1]]: { view: false, edit: false },
      [roles[2]]: { view: false, edit: false },
    },
    paperless_push: {
      [roles[0]]: { view: true, edit: true },
      [roles[1]]: { view: false, edit: false },
      [roles[2]]: { view: false, edit: false },
    },
    cross_sell: {
      [roles[0]]: { view: true, edit: true },
      [roles[1]]: { view: true, edit: false },
      [roles[2]]: { view: true, edit: false },
    },
    up_sell: {
      [roles[0]]: { view: true, edit: true },
      [roles[1]]: { view: true, edit: false },
      [roles[2]]: { view: true, edit: false },
    },
    forms: {
      [roles[0]]: { view: true, edit: true },
      [roles[1]]: { view: true, edit: true },
      [roles[2]]: { view: true, edit: false },
    },
    team: {
      [roles[0]]: { view: true, edit: true },
      [roles[1]]: { view: false, edit: false },
      [roles[2]]: { view: false, edit: false },
    },
    resume: {
      [roles[0]]: { view: true, edit: true },
      [roles[1]]: { view: true, edit: false },
      [roles[2]]: { view: true, edit: false },
    },
    check_ins: {
      [roles[0]]: { view: true, edit: true },
      [roles[1]]: { view: true, edit: false },
      [roles[2]]: { view: true, edit: false },
    },
    reservations: {
      [roles[0]]: { view: true, edit: true },
      [roles[1]]: { view: true, edit: false },
      [roles[2]]: { view: true, edit: false },
    },
    billing: {
      [roles[0]]: { view: true, edit: true },
      [roles[1]]: { view: false, edit: false },
      [roles[2]]: { view: false, edit: false },
    },
    marketing: {
      [roles[0]]: { view: true, edit: true },
      [roles[1]]: { view: true, edit: true },
      [roles[2]]: { view: true, edit: false },
    },
  };

  const isChecked = (permKey, role, type) => {
    return (
      activePermissions[permKey] &&
      activePermissions[permKey][role] &&
      activePermissions[permKey][role][type]
    );
  };

  return (
    <div style={{ overflowX: 'auto' }}>
      <table
        style={{
          borderCollapse: 'collapse',
          width: '100%',
          tableLayout: 'auto',
          fontSize: 14,
        }}
      >
        <thead>
          <tr>
            <th
              rowSpan={2}
              style={{
                textAlign: 'left',
                padding: '6px 8px',
                borderBottom: '1px solid #ccc',
                whiteSpace: 'nowrap',
                width: 100,
              }}
            >
              {translate('team.viewRoles.permission')}
            </th>
            {roles.map(role => (
              <th
                key={role}
                colSpan={2}
                style={{
                  textAlign: 'center',
                  padding: '6px 4px',
                  borderBottom: '1px solid #ccc',
                }}
              >
                {role}
              </th>
            ))}
          </tr>
          <tr>
            {roles.map(role => (
              <React.Fragment key={role}>
                <th
                  style={{
                    width: 40,
                    textAlign: 'center',
                    padding: '2px 4px',
                    borderBottom: '1px solid #ccc',
                    fontWeight: 'normal',
                  }}
                >
                  {translate('team.viewRoles.view')}
                </th>
                <th
                  style={{
                    width: 40,
                    textAlign: 'center',
                    padding: '2px 4px',
                    borderBottom: '1px solid #ccc',
                    fontWeight: 'normal',
                  }}
                >
                  {translate('team.viewRoles.edit')}
                </th>
              </React.Fragment>
            ))}
          </tr>
        </thead>
        <tbody>
          {permissions.map(({ key, label }) => (
            <tr key={key} style={{ borderTop: '1px solid #eee' }}>
              <td
                style={{
                  padding: '6px 8px',
                  whiteSpace: 'nowrap',
                  verticalAlign: 'middle',
                }}
              >
                {label}
              </td>
              {roles.map(role => (
                <React.Fragment key={role}>
                  <td style={{ textAlign: 'center' }}>
                    <Checkbox checked={isChecked(key, role, 'view')} disabled />
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <Checkbox checked={isChecked(key, role, 'edit')} disabled />
                  </td>
                </React.Fragment>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
